import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import { SummaryEmployeeService } from "../../services/summaryEmployee";
import logger from "../../core/utils/logger";

export const getSummaryEmployee=createAsyncThunk(
    'summaryEmployee/getSummaryEmployee',
    async(_, {rejectWithValue})=>{
        try{
            const response=await SummaryEmployeeService.getSummaryListEmployee();
            logger.log("Summary employee response:", JSON.stringify(response));
            return response;
        }catch(error){
            logger.error('Error:', error);
            const errorMessage =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                'Error getting summary employee';
            throw new Error(errorMessage);
        }
    }

);
const initialState={
    summaryEmployee:[],
    loading:false,
    error:null
};

const summaryEmployeeSlice=createSlice({
    name:'summaryEmployee',
    initialState,
    reducers:{
        clearSummaryEmployeeState:(state)=>{
            state.summaryEmployee=[];
            state.loading=false;
            state.error=null;
        }
    },
    extraReducers:(builder)=>{
        builder.addCase(getSummaryEmployee.pending,(state)=>{
            state.loading=true;
            state.error=null;
        });
        builder.addCase(getSummaryEmployee.fulfilled,(state,action)=>{
            state.summaryEmployee=action.payload;
            state.loading=false;
            state.error=null;
        });
        builder.addCase(getSummaryEmployee.rejected,(state,action)=>{
            state.summaryEmployee=[];
            state.loading=false;
            state.error=action.error.message;
        });

      
    }
});
export const {clearSummaryEmployeeState}=summaryEmployeeSlice.actions;
export default summaryEmployeeSlice.reducer;
